/**
 * section-main-blog.js
 * Handles: Load More AJAX, month filter (with multi-page support), share button overlay.
 */

(function () {
  'use strict';

  var grid = document.getElementById('blog-articles-grid');

  // ── Month/tag filter dropdown — navigate to /tagged/ URL ─────────────────

  var monthFilter = document.getElementById('blog-month-filter');
  if (monthFilter) {
    monthFilter.addEventListener('change', function () {
      var blogUrl = this.dataset.blogUrl;
      if (!blogUrl) return;
      if (this.value) {
        window.location.href = blogUrl + '/tagged/' + this.value;
      } else {
        window.location.href = blogUrl;
      }
    });
  }

  // ── Load More ─────────────────────────────────────────────────────────────

  var loadMoreBtn = document.querySelector('.blog-load-more');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      var btn = this;
      var nextUrl = btn.dataset.nextUrl;
      if (!nextUrl) return;

      btn.disabled = true;
      var originalText = btn.textContent.trim();
      btn.textContent = 'Loading\u2026';

      fetch(nextUrl)
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');

          var newArticles = doc.querySelectorAll('#blog-articles-grid .blog-articles-article');
          newArticles.forEach(function (article) {
            grid.appendChild(article);
          });

          // Update total pages count so month filter covers new articles
          var newGrid = doc.getElementById('blog-articles-grid');
          if (newGrid && newGrid.dataset.totalPages) {
            grid.dataset.totalPages = newGrid.dataset.totalPages;
            totalPages = parseInt(newGrid.dataset.totalPages, 10);
          }

          // Update or hide the Load More button
          var nextBtn = doc.querySelector('.blog-load-more[data-next-url]');
          if (nextBtn && nextBtn.dataset.nextUrl) {
            btn.dataset.nextUrl = nextBtn.dataset.nextUrl;
            btn.disabled = false;
            btn.textContent = originalText;
          } else {
            var wrapper = btn.closest('.blog-load-more-wrapper');
            if (wrapper) wrapper.style.display = 'none';
            else btn.style.display = 'none';
          }

          // Re-apply active month filter if one is set
          if (monthFilter && monthFilter.value) {
            filterArticlesInGrid(monthFilter.value);
          }
        })
        .catch(function (err) {
          console.error('[blog] Load More failed:', err);
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  }

  // ── Share button overlay ──────────────────────────────────────────────────

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card-article-share-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var url = btn.dataset.url || window.location.href;
    var title = btn.dataset.title || document.title;

    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {
        // User dismissed — no action needed
      });
    } else if (navigator.clipboard) {
      navigator.clipboard
        .writeText(url)
        .then(function () { showShareFeedback(btn); })
        .catch(function () { fallbackCopyToClipboard(url, btn); });
    } else {
      fallbackCopyToClipboard(url, btn);
    }
  });

  function showShareFeedback(btn) {
    btn.classList.add('is-copied');
    var originalHTML = btn.innerHTML;
    btn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"' +
      ' fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"' +
      ' stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
    setTimeout(function () {
      btn.innerHTML = originalHTML;
      btn.classList.remove('is-copied');
    }, 2000);
  }

  function fallbackCopyToClipboard(url, btn) {
    var textarea = document.createElement('textarea');
    textarea.value = url;
    textarea.style.cssText = 'position:fixed;opacity:0;pointer-events:none;';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      showShareFeedback(btn);
    } catch (_) {
      // Silent fail
    }
    document.body.removeChild(textarea);
  }

  // ── Related posts slider ──────────────────────────────────────────────────

  (function () {
    var track = document.getElementById('related-track');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.article-related-slide'));
    if (slides.length === 0) return;

    var dotsEl = document.getElementById('related-dots');
    var prevBtn = document.querySelector('.article-related-prev');
    var nextBtn = document.querySelector('.article-related-next');
    var currentPage = 0;

    function perPage() {
      if (window.innerWidth >= 990) return 3;
      if (window.innerWidth >= 750) return 2;
      return 1;
    }

    function totalPages() {
      return Math.ceil(slides.length / perPage());
    }

    function goTo(page) {
      var tp = totalPages();
      currentPage = ((page % tp) + tp) % tp;
      var idx = currentPage * perPage();
      if (idx >= slides.length) idx = 0;
      track.style.transform = 'translateX(-' + slides[idx].offsetLeft + 'px)';
      buildDots();
    }

    function buildDots() {
      if (!dotsEl) return;
      var tp = totalPages();

      // Hide controls and disable drag when everything fits on one page
      var single = tp <= 1;
      slider.classList.toggle('article-related--no-slider', single);
      if (prevBtn) prevBtn.style.display = single ? 'none' : '';
      if (nextBtn) nextBtn.style.display = single ? 'none' : '';
      dotsEl.style.display = single ? 'none' : '';
      if (single) return;

      dotsEl.innerHTML = '';
      for (var i = 0; i < tp; i++) {
        (function (p) {
          var dot = document.createElement('button');
          dot.className = 'article-related-dot' + (p === currentPage ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to page ' + (p + 1));
          dot.addEventListener('click', function () { goTo(p); });
          dotsEl.appendChild(dot);
        })(i);
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentPage - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentPage + 1); });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        currentPage = 0;
        track.style.transform = 'translateX(0)';
        buildDots();
      }, 250);
    });

    // ── Drag / swipe support ───────────────────────────────────────────
    var slider = track.parentElement;
    var SWIPE_THRESHOLD = 50;
    var pointerStartX = 0;
    var pointerDeltaX = 0;
    var isPointerDown = false;
    var didDrag = false;

    function currentBaseOffset() {
      var idx = currentPage * perPage();
      if (idx >= slides.length) idx = 0;
      return slides[idx].offsetLeft;
    }

    function isSliderMode() {
      return !slider.classList.contains('article-related--no-slider');
    }

    function onDragStart(clientX) {
      if (!isSliderMode()) return;
      isPointerDown = true;
      didDrag = false;
      pointerStartX = clientX;
      pointerDeltaX = 0;
      track.style.transition = 'none';
    }

    function onDragMove(clientX) {
      if (!isPointerDown) return;
      pointerDeltaX = clientX - pointerStartX;
      if (Math.abs(pointerDeltaX) > 8) {
        didDrag = true;
        slider.classList.add('is-dragging');
      }
      track.style.transform = 'translateX(' + (-currentBaseOffset() + pointerDeltaX) + 'px)';
    }

    function onDragEnd() {
      if (!isPointerDown) return;
      isPointerDown = false;
      slider.classList.remove('is-dragging');
      track.style.transition = '';
      if (Math.abs(pointerDeltaX) >= SWIPE_THRESHOLD) {
        goTo(pointerDeltaX < 0 ? currentPage + 1 : currentPage - 1);
      } else {
        goTo(currentPage);
      }
      setTimeout(function () { didDrag = false; }, 50);
    }

    // Touch events
    slider.addEventListener('touchstart', function (e) {
      onDragStart(e.touches[0].clientX);
    }, { passive: true });

    slider.addEventListener('touchmove', function (e) {
      onDragMove(e.touches[0].clientX);
    }, { passive: true });

    slider.addEventListener('touchend', onDragEnd);
    slider.addEventListener('touchcancel', onDragEnd);

    // Mouse events
    slider.addEventListener('mousedown', function (e) {
      onDragStart(e.clientX);
    });

    window.addEventListener('mousemove', function (e) {
      if (!isPointerDown) return;
      onDragMove(e.clientX);
    });

    window.addEventListener('mouseup', function () {
      if (!isPointerDown) return;
      onDragEnd();
    });

    // Prevent link/button clicks from firing after a drag
    slider.addEventListener('click', function (e) {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
        didDrag = false;
      }
    }, true);

    buildDots();
  })();

})();
